import React from "react";
import { FilterOutlined, TeamOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import ProductLockPage from "components/ProductLock/ProductLockPage";
import lockStyles from "components/ProductLock/style.module.scss";

const AbsLockPage = ({ theme }) => {
  const { t } = useTranslation();
  return (
    <ProductLockPage productKey="advanced_behavioral_segmentation" theme={theme}>
      <div className={lockStyles.lockCardGhostOne}>
        <FilterOutlined />
        <span>{t("abs_lock.ghost_rules")}</span>
        <strong>{t("abs_lock.ghost_builder")}</strong>
      </div>
      <div className={lockStyles.lockCardGhostTwo}>
        <TeamOutlined />
        <span>{t("abs_lock.ghost_audience")}</span>
        <strong>{t("abs_lock.ghost_live")}</strong>
      </div>
    </ProductLockPage>
  );
};

export default AbsLockPage;
